export const routes = {
  EDIT_PRODUCT: '/edit',
}
